import { CellContext } from '@tanstack/react-table';
import { useTranslate } from '@va/localization';
import { Paragraph, paragraphSizes, ParagraphWithTooltip } from '@va/ui/design-system';
import { isNil } from 'lodash';

type ValueOrNullCellProps<T> = { getValue: () => string | null | undefined } & Omit<
  CellContext<T & { itemsInGroup?: string }, unknown>,
  'getValue'
>;

export function ValueOrNullCellV8<T>({ getValue, column, table }: ValueOrNullCellProps<T>) {
  const state = table.getState();
  const isGrouped = column.getIsGrouped();
  const value = getValue();
  const translate = useTranslate();
  const othersGrouped = !isGrouped && state.grouping.length > 0;
  if (isNil(value)) {
    return (
      <Paragraph colorClassName='text-gray-silver' size={paragraphSizes.normal}>
        N/A
      </Paragraph>
    );
  }

  if (othersGrouped) {
    return (
      <ParagraphWithTooltip colorClassName='text-gray-silver' size={paragraphSizes.normal}>
        {Number.parseInt(value) === 1
          ? translate('eventTracking.table.value', { count: value })
          : translate('eventTracking.table.values', { count: value })}
      </ParagraphWithTooltip>
    );
  }

  return (
    <ParagraphWithTooltip colorClassName='text-gray-silver' size={paragraphSizes.normal}>
      {value}
    </ParagraphWithTooltip>
  );
}
